import { createRoute } from '@tanstack/react-router';
import { FiledClaims } from '../filed-claims/index.js';
import { rootRoute } from './index.js';

export const filedClaimsRoute = createRoute({
    getParentRoute: () => rootRoute,
    path: '/filed-claims',
    component: FiledClaims,
});
